import { IInstallment } from "../interfaces";
import InstallmentsModel from "./InstallmentsModel";

class AdvanceModel extends InstallmentsModel {
  public readonly uid: string;
  public readonly contractUid: string;
  public readonly code: number;
  public title: string;
  public readonly date: Date;
  public readonly createdAt: Date;
  public modifiedAt: Date;

  constructor(
    uid: string,
    contractUid: string = "",
    code: number = 1,
    title: string = "",
    date = new Date(),
    installments: IInstallment[] = [],
    createAt = new Date(),
    modifiedAt = new Date()
  ) {
    super(date, installments);

    this.uid = uid;
    this.contractUid = contractUid;
    this.code = code;
    this.title = title;
    this.date = date;
    this.createdAt = createAt;
    this.modifiedAt = modifiedAt;
  }

  getDate(): Date | undefined {
    /** Cria nova instancia para não alterar a data do adiantamento. */
    return this.date ? new Date(this.date) : undefined;
  }

  toSave() {
    return {
      code: this.code,
      title: this.title,
      date: this.date,
      installments: [...this.installments],
      createdAt: this.createdAt,
      modifiedAt: this.modifiedAt,
    };
  }

  static create(uid: string, data: Partial<AdvanceModel>): AdvanceModel {
    return new AdvanceModel(
      uid,
      data.contractUid,
      data.code,
      data.title,
      data.date,
      data.installments,
      data.createdAt,
      data.modifiedAt
    );
  }
}

export default AdvanceModel;
